import React from 'react';
import { Input, Row, Col } from 'antd';

interface RangeOptionsFilterProps {
  isMobile: boolean;
  minName: string;
  maxName: string;
  title: string;
  optionId: number;
  onRangeChange: (optionId: number, minValue: any, maxValue: any, title: string) => void;
  minValue?: any;
  maxValue?: any;
}

const RangeOptionsFilter: React.FC<RangeOptionsFilterProps> = ({
  isMobile,
  minName,
  maxName,
  title,
  optionId,
  onRangeChange,
  minValue = null,
  maxValue = null
}) => {
  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onRangeChange(optionId, value || null, maxValue, title);
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onRangeChange(optionId, minValue, value || null, title);
  };

  return (
    <Row gutter={8}>
      <Col span={12}>
        <Input
          placeholder={`Min ${title}`}
          value={minValue || ''}
          onChange={handleMinChange}
          type="number"
        />
      </Col>
      <Col span={12}>
        <Input
          placeholder={`Max ${title}`}
          value={maxValue || ''}
          onChange={handleMaxChange}
          type="number"
        />
      </Col>
    </Row>
  );
};

export default RangeOptionsFilter;